export default {
  SUPPER_ADMIN: "superadmin",
  ADMIN: "admin",
  USER: "user",
};
